export default "__VITE_ASSET__B$GHNX_i__"